import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from './utils/request'
// 引入Vuex.Store实例
import store from './store'
import moment from 'moment'

// 引入vant组件库
import Vant, { Lazyload } from 'vant'

import { Popover } from 'vant'
Vue.use(Popover);
import 'vant/lib/index.css'

// 它会根据的手机尺寸来调整rem的基准值：html标签上的font-size。
import 'amfe-flexible'

import Meta from 'vue-meta'
Vue.use(Meta)


// 时间过滤器
import { relativeTime } from '@/utils/date-time'
/*引入axios插件*/
Vue.prototype.$http = axios;

// 定义一个全局过滤器，对时间进行相对计算
Vue.filter('relativeTime', relativeTime)
Vue.filter('moment', function(value){
    return moment(value).format('YYYY-MM-DD')
})
Vue.filter('momentSS', function(value){
    return moment(value).format('YYYY-MM-DD   HH:mm:ss')
})
// 使用懒加载
Vue.use(Lazyload)
// Vue.use(Popover);

// 注册插件
Vue.use(Vant)

// 注册事件总线
// 给Vue这个构造器的原型对象上添加一个属性，名字是： $eventBus。这个名字是可以自已写的。
// 这个属性的值是 ：new Vue()。 表示Vue的一个新的实例。
// 由于给vue的构造器的原型对象添加了属性，所有的组件的都是通过Vue构造器创建的，
// 所以，在任意组件内部，我们都可以通过this.$eventBus来访问这个事件总线
Vue.prototype.$eventBus = new Vue()




new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')